import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _17mpIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"17mp"} ref={ref}/>
});

_17mpIcon.displayName = "_17mpIcon";
